import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/system/Box";
import Image from "next/image";
import { useDispatch, useSelector } from "react-redux";
import { upgradeModalHided } from "src/slices/system";
import {
  selectIsBriefLimit,
  selectIsUpgradeModalOpen,
} from "src/slices/system/selectors";

type Props = {};

const UpgradeModal = (props: Props) => {
  const open = useSelector(selectIsUpgradeModalOpen);
  const isBriefLimit = useSelector(selectIsBriefLimit);
  const dispatch = useDispatch();
  const handleOnClose = () => {
    dispatch(upgradeModalHided());
  };

  const handleOnCtaClick = () => {
    window.open("https://calendly.com/tomwinter/virtual-coffee", "_blank");
    dispatch(upgradeModalHided());
  };
  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={handleOnClose}>
      <Box sx={{ p: 3 }}>
        <Typography align="center" variant="h5">
          {isBriefLimit
            ? "You've reached a limit of briefs in your plan"
            : "Want to try the full version of SEOwind?"}
        </Typography>
        <Typography align="center" variant="body2" gutterBottom>
          {isBriefLimit
            ? "Contact us to upgrade your plan or renew your subscription"
            : "Unlock 7 days of the upgraded plan and share your feedback - it's a win-win."}
        </Typography>
        <Grid container sx={{ pt: 3 }}>
          <Grid xs={5}>
            <Image src="/app/images/popup-image.png" width={200} height={257} />
          </Grid>
          <Grid xs={7}>
            <Typography variant="body1" gutterBottom>
              You’ll get access to these powerful features:
            </Typography>
            <Typography variant="body2">
              <Box sx={{ display: "flex", alignItems: "center", pb: 0.5 }}>
                <CheckCircleOutlineIcon fontSize="inherit" sx={{ mr: 1 }} />
                Create more briefs
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", pb: 0.5 }}>
                <CheckCircleOutlineIcon fontSize="inherit" sx={{ mr: 1 }} />
                Use AI to create the SEO outline for you
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", pb: 0.5 }}>
                <CheckCircleOutlineIcon fontSize="inherit" sx={{ mr: 1 }} />
                Get additional secondary keywords
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", pb: 0.5 }}>
                <CheckCircleOutlineIcon fontSize="inherit" sx={{ mr: 1 }} />
                Get questions your audience asks
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", pb: 0.5 }}>
                <CheckCircleOutlineIcon fontSize="inherit" sx={{ mr: 1 }} />
                Analyse much more data
              </Box>
            </Typography>
          </Grid>
        </Grid>

        <Button
          color="primary"
          variant="contained"
          fullWidth
          sx={{ mt: 4 }}
          onClick={handleOnCtaClick}
        >
          Let’s meet and talk
        </Button>
      </Box>
    </Dialog>
  );
};

export default UpgradeModal;
